export default __webpack_public_path__ + "static/O0116-ee01c9a53fff5ac008c6ad1e945f3171.png";